import { render, staticRenderFns } from "./CreateFaq.vue?vue&type=template&id=bb28886a&scoped=true&"
import script from "./CreateFaq.vue?vue&type=script&lang=js&"
export * from "./CreateFaq.vue?vue&type=script&lang=js&"
import style0 from "./CreateFaq.vue?vue&type=style&index=0&id=bb28886a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb28886a",
  null
  
)

export default component.exports